import { render, staticRenderFns } from "./TrianglePropertiesViz.vue?vue&type=template&id=f19b0d62&scoped=true"
import script from "./TrianglePropertiesViz.vue?vue&type=script&lang=js"
export * from "./TrianglePropertiesViz.vue?vue&type=script&lang=js"
import style0 from "./TrianglePropertiesViz.vue?vue&type=style&index=0&id=f19b0d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19b0d62",
  null
  
)

export default component.exports